import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChecksheetChangeService {
  private dataSource = new BehaviorSubject<any>(null);
  dataChanges$ = this.dataSource.asObservable();

  /** Fired when step message unread counts change (e.g. ghost unread reconciled). */
  private messageCountsChangedSource = new Subject<void>();
  messageCountsChanged$ = this.messageCountsChangedSource.asObservable();

  // ReplaySubject for navigation requests from chat to academy
  // Using ReplaySubject(1) so the last emitted value is replayed to new subscribers
  private navigateToStepSource = new ReplaySubject<number>(1);
  navigateToStep$ = this.navigateToStepSource.asObservable();

  updateData(data: any) {
    this.dataSource.next(data);
  }

  notifyMessageCountsChanged(): void {
    this.messageCountsChangedSource.next();
  }

  /**
   * Request navigation to a specific step by student_course_step_id
   * The academy details component will handle finding the step and navigating
   */
  requestNavigateToStep(studentCourseStepId: number) {
    console.log('🚀 ChecksheetChangeService: requesting navigation to step:', studentCourseStepId);
    this.navigateToStepSource.next(studentCourseStepId);
  }
}
